// extracted by mini-css-extract-plugin
export default {"chartPlaceHolder":"Parking_chartPlaceHolder__BtE7O","chartLegend":"Parking_chartLegend__FRIDY"};